import { useState, useMemo, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { take } from 'lodash'

import Barcode from 'react-barcode'
import { Container, Grid, TextField, Stack, Button, Typography } from '@mui/material'

export const paginate = (collection, limit = 400) => {

  let list = [...collection];
  let result = [];

  while (list.length !== 0) {

    const taken = take(list, limit);
    result = [...result, taken];
    list = list.filter(one => !taken.includes(one));

  }

  return result;
};
export default function BarcodeGen(){
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [start, setStart] = useState(92)
  const [end, setEnd] = useState(start + 100)

  const list = useMemo(() => {
    const count = end - start + 1;
    const finalCount = count < 0 ? 0 : count

    return [...Array(finalCount)].map((_, idx) => {
      const index = Number(idx) + start;
      return `DS${'0'.repeat(11 - String(index).length)}${index}`;
    });
  }, [start, end])

 
  return (
    <Container maxWidth='md'>

      <Typography variant='h3'>
        Barcode Printer
      </Typography>

      <Stack direction={'row'} spacing={1} my={5}>
        <TextField
          fullWidth
          label={'start'}
          type={'number'}
          value={start}
          onChange={e => setStart(Number(e.target.value))}
        />
        <TextField
          fullWidth
          label={'end'}
          type={'number'}
          value={end}
          onChange={e => setEnd(Number(e.target.value))}
        />
        <Button variant='contained' onClick={handlePrint}>
          print
        </Button>
      </Stack>

      <div ref={componentRef} >
        {
          paginate(list, 14)?.map((list=[], key) => (
            <div key={key} style={{ marginBottom: 150 }}>
              <Grid container justifyContent={'center'}>
                {
                  list.map(id => (
                    <Grid item key={id}>
                      <Barcode value={id} />
                    </Grid>
                  ))
                }
              </Grid>
            </div>

          ))
        }
      </div>


    </Container>

  );
};
